module.exports = __webpack_public_path__ + "img/cloud_download.02f2a976.svg";